// extracted by mini-css-extract-plugin
module.exports = {"combobox":"header_combobox__1u3Bh","menu":"header_menu__2E0HY"};